<template>
  <!-- mobile actions bar -->
  <v-bottom-navigation
    background-color="secondary"
    height="90"
    v-if="$vuetify.breakpoint.smAndDown"
    dark
    grow
    fixed
  >
    <v-dialog
      v-if="authenticated"
      v-model="buyNow"
      fullscreen
      transition="dialog-bottom-transition"
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="flipAsset.allowBuyItNow"
          :disabled="flipAsset.salesState !== 'ForSale' && flipAsset.salesState !== 'SoldOut'"
          v-bind="attrs"
          v-on="on"
        >
          <span>Buy Car</span>
          <v-icon>mdi-cash-multiple</v-icon>
        </v-btn>
      </template>
      <BuyItNowForm
        v-on:dialog-close="buyNow = false"
      ></BuyItNowForm>
    </v-dialog>
    <v-btn
      v-else-if="flipAsset.allowBuyItNow"
      :disabled="flipAsset.salesState !== 'ForSale' && flipAsset.salesState !== 'SoldOut'"
      @click="bounceBack"
    >
      <span>Buy Car</span>
      <v-icon>mdi-cash-multiple</v-icon>
    </v-btn>

    <v-btn
      :href="flipAsset.auctionLink"
      :disabled="flipAsset.salesState !== 'InAuction'"
      target="_blank"
    >
      <span>Go To Auction</span>
      <v-icon>mdi-bullhorn-outline</v-icon>
    </v-btn>

    <v-dialog
      v-if="authenticated"
      fullscreen
      transition="dialog-bottom-transition"
      v-model="buyShares"
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="flipAsset.salesState === 'SoldOut' || flipAsset.salesState === 'Purchased' || flipAsset.salesState === 'InAuction' || flipAsset.salesState === 'Suspended' || flipAsset.salesState === 'PendingPurchase'"
          v-bind="attrs"
          v-on="on"
        >
          <span>Buy Shares</span>
          <v-icon>mdi-finance</v-icon>
        </v-btn>
      </template>
      <PurchaseShareForm
          ref="purchaseForm"
        v-on:dialog-close="buyShares = false"
      ></PurchaseShareForm>
    </v-dialog>
    <v-btn
      v-else
      @click="bounceBack"
      :disabled="flipAsset.salesState === 'SoldOut' || flipAsset.salesState === 'Purchased' || flipAsset.salesState === 'InAuction' || flipAsset.salesState === 'Suspended' || flipAsset.salesState === 'PendingPurchase'"
    >
      <span>Buy Shares</span>
      <v-icon>mdi-finance</v-icon>
    </v-btn>

  </v-bottom-navigation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PurchaseShareForm from './PurchaseShareForm.vue'
  import BuyItNowForm from './BuyItNowForm.vue'

  export default {
    name: 'AssetMobileActions',

    components: {
      PurchaseShareForm,
      BuyItNowForm
    },

    computed: {
      ...mapGetters([
        'authenticated',
        'loginRedirect',
        'flipAsset'
      ])
    },

    data: () => ({
      // Dialog handling.
      buyShares: false,
      buyNow: false
    }),

    watch: {
      buyShares(visible) {
        if (visible) {
          if (this.$refs.purchaseForm) {
            this.$refs.purchaseForm.dialogOpen()
          }
        }
      }
    },

    methods: {
      bounceBack: function() {
        this.$cookies.set('assetBounce', this.flipAsset.id, '', '/')
        window.location.href = this.loginRedirect
      }
    }
  }
</script>
